var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0029 4.00001C20.8388 3.99801 19.6902 4.2677 18.6486 4.78762C17.607 5.30755 16.7011 6.06336 16.0029 6.99494C15.0574 5.73687 13.7402 4.808 12.2376 4.33976C10.7351 3.87153 9.12341 3.88764 7.63055 4.38582C6.1377 4.884 4.8393 5.83901 3.91909 7.11574C2.99888 8.39246 2.50346 9.92623 2.50293 11.5C2.50293 20.4829 14.983 27.575 15.5143 27.8725C15.6636 27.9561 15.8318 28 16.0029 28C16.174 28 16.3423 27.9561 16.4916 27.8725C18.7869 26.5282 20.9412 24.9563 22.9219 23.1808C27.2887 19.2506 29.5029 15.3206 29.5029 11.5C29.5007 9.51158 28.7098 7.60523 27.3037 6.1992C25.8977 4.79316 23.9914 4.00226 22.0029 4.00001Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFill);
export default __webpack_public_path__ + "static/media/like-fill.aff6d9d4c23f53312beea16a29d692ee.svg";
export { ForwardRef as ReactComponent };